var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pack_container" }, [
    _c("div", { staticClass: "card_header", style: _vm.headerStyle }, [
      _c("span", [_vm._v(_vm._s("Pack"))]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.packName))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card_main", style: _vm.mainStyle }, [
      _c("div", { style: "color:" + _vm.colors.mainText }, [
        _c("span", { staticClass: "pack_price" }, [
          _c("span", { staticClass: "pack_currency" }, [
            _vm._v(_vm._s(_vm.currency))
          ]),
          _vm._v(_vm._s(_vm.price))
        ]),
        _vm._v(" /" + _vm._s(_vm.period) + "\n          ")
      ]),
      _vm._v(" "),
      _c(
        "ul",
        _vm._l(_vm.offersList, function(item, index) {
          return _c("li", { key: index, staticClass: "offer_item" }, [
            _c("span", {
              staticClass: "check_mark",
              style: { borderColor: _vm.checkColor }
            }),
            _vm._v(" " + _vm._s(item))
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn_container" },
        [
          _c(
            "Button",
            _vm._b(
              {
                on: {
                  click: function($event) {
                    return _vm.$emit("handleclick")
                  }
                }
              },
              "Button",
              _vm.button,
              false
            )
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4cf86e85", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cf86e85","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/PlanCard.vue
// module id = null
// module chunks = 